import { useEffect, useState } from "react";
import { API } from "../../../config";

export const CategorySelector = ({
  value,
  onChange,
  placeholder,
  fieldName,
  error,
  submitted,
  styles,
}) => {
  const [categories, setCategories] = useState([]);
  const getCategories = async () => {
    const data = await fetch(`${API}/Admin/category/get`);
    const json = await data.json();
    setCategories(json.allcategory);
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <select
      className={`${styles.input} ${
        error && submitted ? styles.inputError : ""
      }`}
      name={fieldName}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{placeholder}</option>
      {categories.map((category) => (
        <option key={category._id} value={category._id}>
          {category.name}
        </option>
      ))}
    </select>
  );
};
